import React, { useEffect, useState } from "react";
import { isValidEmail } from "../../helpers/common";
import {
  Logo,
  MailIcon,
  FacebookIcon,
  LinkedinIcon,
  TwitterIcon,
  InstagramIcon,
  FooterLogo,
  CheckIcon,
} from "../../assets";
import Navbar from "../../component/Navbar";
import { useNavigate } from "react-router-dom";
import { addContact } from "../../services/Auth";
import InfoDialog from "../../component/dialogs/InfoDialog";

const Contact = () => {
  const navigate = useNavigate();
  const initialValues = {
    firstname: "",
    lastname: "",
    phone: "+44",
    email: "",
    service: "AI Lab",
    message: "",
  };

  const errorsField = {
    firstname: "First name",
    lastname: "Last name",
    email: "Email",
    message: "Message",
  };

  const [formValues, setFormValues] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      document
        .getElementById("contact-main-wrapper")
        ?.scrollIntoView({ behavior: "smooth" });
    }, 500);
  }, []);

  const validateStep = () => {
    let newErrors = {};
    if (!formValues.firstname) newErrors.firstname = "First name is required";
    if (!formValues.lastname) newErrors.lastname = "Last name is required";
    if (!formValues.email) {
      newErrors.email = "Email is required";
    } else if (!isValidEmail(formValues.email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!formValues.service) newErrors.service = "service is required";
    if (!formValues.message) newErrors.message = "Message is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const renderLabel = (label) => (
    <label className="text-white text-lg font-medium leading-7">{label}</label>
  );
  const renderInputField = (name, placeholder, label, type = "text") => (
    <div className="flex flex-col items-start gap-2 flex-1">
      {renderLabel(label)}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={formValues[name]}
        onBlur={() => handleFieldChange(name, formValues?.[name]?.trim())}
        onChange={(e) => {
          const inputValue = e.target.value;
          if (name === "phone") {
            // Ensure +44 prefix remains intact and allow only digits after +44
            const phoneValue = "+44" + inputValue.slice(3).replace(/\D/g, "");
            handleFieldChange(name, phoneValue);
          } else {
            handleFieldChange(name, inputValue);
          }
        }}
        className="w-full placeholder:normal-case h-12 rounded-lg border border-[rgba(255,255,255,0.12)] bg-transparent px-4 py-3 text-base text-[rgba(255,255,255,0.6)] font-normal leading-6"
      />
      {errors[name] && (
        <div className="text-[13px] leading-5 -tracking-[0.13px] font-normal text-[#FF352A]">
          {errors[name]}
        </div>
      )}
    </div>
  );
  const handleSubmit = async () => {
    if (validateStep()) {
      setLoading(true);
      try {
        await addContact({
          firstName: formValues.firstname,
          lastName: formValues.lastname,
          email: formValues.email,
          phone: formValues.phone,
          message: formValues.message,
          service: formValues.service,
        });
        setInfoOpen(true);
      } catch (error) {
        console.log("error", error);
      }

      setLoading(false);
      setFormValues({
        firstname: "",
        lastname: "",
        phone: "+44",
        email: "",
        service: "",
        message: "",
      });
    }
  };
  const handleFieldChange = (fieldName, value) => {
    const newValues = { ...formValues, [fieldName]: value };
    setFormValues(newValues);
    console.log("newValues", newValues);
    // Real-time validation for changed field
    let newErrors = { ...errors };
    if (fieldName === "email") {
      if (!value) {
        newErrors.email = "Email is required";
      } else if (!isValidEmail(value)) {
        newErrors.email = "Please enter a valid email address";
      } else {
        delete newErrors.email;
      }
    } else if (fieldName === "phone") {
      const formattedValue = value.replace(/\D/g, "");
      if (formattedValue.includes("44") && formattedValue.length === 2) {
        delete newErrors.phone;
      } else if (formattedValue.length !== 12) {
        // phone numbers have 44 + 10 digits
        newErrors.phone = "Please enter a valid UK phone number";
      } else {
        delete newErrors.phone;
      }
    } else {
      if (!value) {
        newErrors[fieldName] = `${errorsField[fieldName]} is required`;
      } else {
        delete newErrors[fieldName];
      }
    }
    setErrors(newErrors);
  };
  return (
    <div className="bg-[#141414] font-satoshi" id="contact-main-wrapper">
      <Navbar />
      {infoOpen && (
        <InfoDialog
          open={infoOpen}
          setOpen={() => setInfoOpen(false)}
          infoDetail={{
            heading:
              "Thanks for your inquiry, our agent will be in touch in 24 hours.",
            innerContent: "",
          }}
          handleSubmit={() => {}}
          icon={CheckIcon}
        />
      )}
      <div className="w-full max-w-[668px] mx-auto px-4 pt-[80px] pb-[120px] flex flex-col gap-11 items-center">
        <div className="text-center space-y-4">
          <h2 className="font-bold text-[56px] leading-[68px] text-white">
            Contact
          </h2>
          <p className="text-base font-normal leading-6 text-[rgba(255,255,255,0.88)]">
            Want to get a quote? contact us today
          </p>
        </div>

        <div className="p-6 border border-[rgba(255,255,255,0.16)] rounded-3xl space-y-16 w-full">
          <h2 className="text-[40px] leading-[48px] text-center font-medium text-white">
            Get In Touch
          </h2>
          <div className="space-y-6">
            <div className="flex md:flex-row flex-col gap-4">
              {renderInputField("firstname", "First Name", "First Name")}
              {renderInputField("lastname", "Last Name", "Last Name")}
            </div>
            {renderInputField(
              "phone",
              "Phone Number",
              "Phone Number (Optional)"
            )}
            {renderInputField("email", "Email", "Email")}
            <div className="flex flex-col gap-4 items-start">
              <label className="text-white text-lg font-medium leading-7">
                Service
              </label>
              <select
                name="service"
                placeholder="Select service"
                label="service"
                id="large"
                value={formValues.service}
                className="w-full placeholder:normal-case h-12 rounded-lg border border-[rgba(255,255,255,0.12)] bg-transparent px-4 py-3 text-base text-[rgba(255,255,255,0.6)] font-normal leading-6"
                onChange={(event) =>
                  handleFieldChange("service", event.target.value)
                }
              >
                <option className="text-black" value="AI Lab">
                  AI Lab
                </option>
                <option className="text-black" value="Mentorship Lab">
                  Mentorship Lab
                </option>
                <option className="text-black" value="Web Lab">
                  Web Lab
                </option>
              </select>
            </div>
            <div className="flex flex-col gap-4 items-start">
              <label className="text-white text-lg font-medium leading-7">
                Message
              </label>
              <textarea
                name="message"
                rows="5"
                label="message"
                placeholder={`Type our message here...`}
                value={formValues.message || ""}
                onChange={(e) => {
                  setFormValues({
                    ...formValues,
                    message: e.target.value,
                  });
                  handleFieldChange("message", e.target.value);
                }}
                className="input text-[rgba(255,255,255,0.6)] bg-transparent border border-[rgba(255,255,255,0.12)] rounded-lg py-4 px-4 block w-full outline-none resize-none"
              />
              {errors.message && (
                <div className="text-[13px] leading-5 -tracking-[0.13px] font-normal text-[#FF352A] ">
                  {errors.message}
                </div>
              )}
            </div>
          </div>
          <button
            className="!normal-case normal-case!h-12 !py-3 !px-4 !w-full !bg-[rgba(179,7,7,1)] !border-[1px] !border-solid !border-[rgba(248,21,21,1)] !text-base text-white !font-bold !rounded-lg !leading-6 disabled:opacity-30"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
      {/* Footer section start */}
      <section className="h-full md:max-h-[516px] max-h-fit bg-[#FFFFFF1F] backdrop-blur-[80px] md:pb-12 pb-7">
        <div className="w-full 2xl:max-w-[1240px] xl:max-w-[1024px] lg:max-w-[768px] md:max-w-[640px] max-w-full md:px-0 px-4 mx-auto lg:pt-[160px] md:pt-[120px] pt-[40px]">
          <div className="w-full flex justify-between pb-10 border-b border-[#FFFFFF1F] lg:flex-nowrap flex-wrap md:gap-0 gap-3">
            <div className="flex flex-col gap-8">
              <img
                src={FooterLogo}
                alt="logo"
                className="w-auto max-h-[32px]"
              />
              {/* <div className="flex gap-4">
                <img
                  src={FacebookIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={LinkedinIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={TwitterIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                />
                <img
                  src={InstagramIcon}
                  alt="socialIcon"
                  className="cursor-pointer"
                  onClick={() =>
                    window.open(
                      "https://www.instagram.com/incognetolabs?igsh=MXRsazF5bzZrcnB0bg==",
                      "_blank"
                    )
                  }
                />
              </div> */}
            </div>
            <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Company
              </h5>
              <ul className="list-none flex flex-col gap-4">
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() => {
                    navigate("/");
                  }}
                >
                  Home
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() => {
                    navigate("/saas");
                  }}
                >
                  Saas Developments
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() => {
                    navigate("/mentorship");
                  }}
                >
                  Mentorship
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() => {
                    navigate("/ai-integration");
                  }}
                >
                  AI Integrations
                </li>
                <li
                  className="text-base leading-6 font-normal text-[#FFFFFFE0] cursor-pointer"
                  onClick={() =>
                    document
                      .getElementById("contact-main-wrapper")
                      .scrollIntoView({ behavior: "smooth" })
                  }
                >
                  Contact
                </li>
              </ul>
            </div>
            {/* <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Legal
              </h5>
              <ul className="list-none flex flex-col gap-4">
                <li className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  Terms of use
                </li>
                <li className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  Privacy Policy
                </li>
              </ul>
            </div> */}
            <div className="flex flex-col gap-5">
              <h5 className="m-0 text-lg leading-7 font-bold text-white">
                Support
              </h5>
              <div className="flex items-center gap-4">
                <img src={MailIcon} alt="emailIcon" />
                <span className="text-base leading-6 font-normal text-[#FFFFFFE0]">
                  contact@incognetolabs.com
                </span>
              </div>
            </div>
          </div>
          <div className="w-full pt-3">
            <span className="text-base leading-6 font-normal text-white">
              © 2024 incognetoLabs. All rights reserved.
            </span>
          </div>
        </div>
      </section>
      {/* Footer section end */}
    </div>
  );
};

export default Contact;
